import { css } from 'styled-system/css';
import type { BillingFrequency } from '../../billing/billingFrequency';

export function FrequencyButton({
  frequency,
  label,
  selected,
  onSelect,
}: {
  frequency: BillingFrequency;
  label: string;
  selected: boolean;
  onSelect: (frequency: BillingFrequency) => void;
}) {
  function handleClick() {
    onSelect(frequency);
  }

  return (
    <button
      type="button"
      data-testid={`billing-${frequency}`}
      aria-pressed={selected}
      onClick={handleClick}
      className={css({
        height: { base: '8', md: '6' },
        paddingInline: { base: '3', md: '2.5' },
        fontSize: { base: 'xs', md: '2xs' },
        fontWeight: 'semibold',
        cursor: 'pointer',
        background: selected ? 'accent.default' : 'transparent',
        color: selected ? 'text.onAccent' : 'text.secondary',
        transition: 'background 200ms {easings.out}, color 200ms {easings.out}',
        _hover: { color: selected ? 'text.onAccent' : 'text.primary' },
        _focusVisible: {
          outline: '2px solid token(colors.border.focus)',
          outlineOffset: '2px',
        },
      })}
    >
      {label}
    </button>
  );
}
